import { render, staticRenderFns } from "./ReportsDetailView.vue?vue&type=template&id=729e3f1f&scoped=true"
import script from "./ReportsDetailView.vue?vue&type=script&lang=js"
export * from "./ReportsDetailView.vue?vue&type=script&lang=js"
import style0 from "./ReportsDetailView.vue?vue&type=style&index=0&id=729e3f1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729e3f1f",
  null
  
)

export default component.exports